import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';

import Dashboard from './pages/Dashboard';

import UsersAll from './pages/Users/All';
import UsersFeatured from './pages/Users/Featured';
import UsersIndividual from './pages/Users/Individual';

import CategoriesAll from './pages/Categories/All';
import InterestsAll from './pages/Interests/All';

import ListsAll from './pages/Lists/All';
import ListsFeatured from './pages/Lists/Featured';
import ListsIndividual from './pages/Lists/Individual';

import ArticlesAll from './pages/Articles/All';
import ArticlesFeatured from './pages/Articles/Featured';
import ArticlesIndividual from './pages/Articles/Individual';

import CarouselsAll from './pages/Carousels/All';
import CarouselsIndividual from './pages/Carousels/Individual';

import ProductsAll from './pages/Products/All';
import ProductsFeatured from './pages/Products/Featured';
import ProductsIndividual from './pages/Products/Individual';

import VideosAll from './pages/Videos/All';
import VideosIndividual from './pages/Videos/Individual';

import AffiliatesAll from './pages/Affiliates/All';
import AffiliatesManage from './pages/Affiliates/Manage';

import TagsAll from './pages/Tags/All';
import ProfessionsAll from './pages/Professions/All';
import SiteCopyAll from './pages/SiteCopy/All';
import VanityLinksAll from './pages/VanityLinks/All';

import Search from './pages/Search';
import Reports from './pages/Reports';

import HomepageHeroItemsAll from './pages/Homepage/Hero/All';
import HomepageSettingsAll from './pages/Homepage/Settings/All';

import CtaContextsAll from './pages/Ctas/Contexts';

import BrandsAll from './pages/Brands/All';
import BrandsIndividual from './pages/Brands/Individual';

import QRCodesAll from './pages/QRCodes/All';
import QRCodesIndividual from './pages/QRCodes/Individual';

const NoMatch = () => { return (<div>No such page</div> ); };

class Router extends Component {
    render() {
        const { match } = this.props;
        const matchUrl = match.url;

        return (
            <Switch>
                <Route exact path={ matchUrl } component={ Dashboard } />

                <Route exact path={ `${ matchUrl }/users` } component={ UsersAll } />
                <Route exact path={ `${ matchUrl }/users/featured` } component={ UsersFeatured } />
                <Route exact path={ `${ matchUrl }/users/:uid` } component={ UsersIndividual } />

                <Route exact path={ `${ matchUrl }/categories` } component={ CategoriesAll } />

                <Route exact path={ `${ matchUrl }/interests` } component={ InterestsAll } />

                <Route exact path={ `${ matchUrl }/lists` } component={ ListsAll } />
                <Route exact path={ `${ matchUrl }/lists/featured` } component={ ListsFeatured } />
                <Route exact path={ `${ matchUrl }/lists/:lid` } component={ ListsIndividual } />

                <Route exact path={ `${ matchUrl }/content` } component={ ArticlesAll } />
                <Route exact path={ `${ matchUrl }/content/featured` } component={ ArticlesFeatured } />
                <Route exact path={ `${ matchUrl }/content/:aid` } component={ ArticlesIndividual } />

                <Redirect exact from={ `${ matchUrl }/articles` } to={ `${ matchUrl }/content` } />
                <Redirect exact from={ `${ matchUrl }/articles/featured` } to={ `${ matchUrl }/content/featured` } />
                <Redirect exact from={ `${ matchUrl }/articles/:aid` } to={ `${ matchUrl }/content/:aid` } />

                <Route exact path={ `${ matchUrl }/carousels` } component={ CarouselsAll } />
                <Route exact path={ `${ matchUrl }/carousels/:id` } component={ CarouselsIndividual } />

                <Route exact path={ `${ matchUrl }/videos` } component={ VideosAll } />
                <Route exact path={ `${ matchUrl }/videos/:id` } component={ VideosIndividual } />

                <Route exact path={ `${ matchUrl }/products` } component={ ProductsAll } />
                <Route exact path={ `${ matchUrl }/products/featured` } component={ ProductsFeatured } />
                <Route exact path={ `${ matchUrl }/products/:pid` } component={ ProductsIndividual } />

                <Route exact path={ `${ matchUrl }/affiliates` } component={ AffiliatesAll } />
                <Route exact path={ `${ matchUrl }/affiliates/manage` } component={ AffiliatesManage } />

                <Route exact path={ `${ matchUrl }/tags` } component={ TagsAll } />

                <Route exact path={ `${ matchUrl }/professions` } component={ ProfessionsAll } />

                <Route exact path={ `${ matchUrl }/site-copy` } component={ SiteCopyAll } />

                <Route exact path={ `${ matchUrl }/vanity-links` } component={ VanityLinksAll } />

                <Route exact path={ `${ matchUrl }/search` } component={ Search } />
                <Route exact path={ `${ matchUrl }/reports` } component={ Reports } />

                <Route exact path={ `${ matchUrl }/homepage/settings` } component={ HomepageSettingsAll } />
                <Route exact path={ `${ matchUrl }/homepage/:context` } component={ HomepageHeroItemsAll } />

                <Route exact path={ `${ matchUrl }/ctas/contexts` } component={ CtaContextsAll } />
                <Route exact path={ `${ matchUrl }/ctas/items/:context` } component={ HomepageHeroItemsAll } />

                <Route exact path={ `${ matchUrl }/brands` } component={ BrandsAll } />
                <Route exact path={ `${ matchUrl }/brands/:bid` } component={ BrandsIndividual } />

                <Route exact path={ `${ matchUrl }/qr_codes` } component={ QRCodesAll } />
                <Route exact path={ `${ matchUrl }/qr_codes/:qrid` } component={ QRCodesIndividual } />

                <Route component={ NoMatch } />
            </Switch>
        );
    }
}

export default withRouter( Router );
